import * as variables from '~/styles/variables.scss';
import { MyDeals } from './pages/my-deals';
import { MyMoney } from './pages/my-money';
import { MySongs } from './pages/my-songs';
import { MyTeam } from './pages/my-team';

export const name = 'dashboard';

export const FEATURE_ROUTER_PATH = `/${name}`;

export const NAV_DRAWER_ITEMS = {
    team: {
        background: variables.colorOrange,
        link: '/team',
        title: 'My team',
        page: MyTeam,
        icon: 'PeopleIcon',
    },
    deals: {
        background: variables.colorYellow,
        link: '/deals',
        title: 'My deals',
        page: MyDeals,
        icon: 'ThumbsUpDownIcon',
    },
    songs: {
        background: variables.colorBlue,
        link: '/songs',
        title: 'My songs',
        page: MySongs,
        icon: 'LibraryMusicIcon',
    },
    money: {
        background: variables.colorGreen,
        link: '/money',
        title: 'My money',
        page: MyMoney,
        icon: 'MoneyIcon',
    },
};

export const ActiveReportJSKey =
    'Korrect SW,E253643315696919#B0uJ8RDtUNEhkQDJkc0hlawsWNJN4TPdWVtV6VWlEOlFjQGlHWPZkRhZGO9QmVBlzd9kXQpp7bI3md8Zmeal7Rz8mNMpEdztSZmJUYHdEWStUYNFlYnRGTxZ7Uwd5dZB7bXNEam3UUGpFd9tkdjlFaaNUWGpWU6NTVwdWbylXY7omMvtUSRFHSDxkewJTaX54QaZTZFlGNlZUSDhlMExUR7U7Khh6bUFWeUVDOHd7dQ54NFZjbRhEeGx4ZmxmSRpke8p5K7IGdE9kW6JEa6IUds5WTHhmcCJWRT9kYYJ4R5x4RPFTZwBValV5a89UZrIld7pmI0IyUiwiI7cDNzczQFNjI0ICSiwyM4MDO9gTNxYTM0IicfJye#4Xfd5nIJZVQFJiOiMkIsIiMWByUKRncvBXZSVmdpR7YBJiOi8kI1tlOiQmcQJCLiQzMxAjMwAiNwcDMxIDMyIiOiQncDJCLiUDM8ATMyAjMiojIwhXRiwiIXNFI4NWZyJ7bLJiOiEmTDJCLlVnc4pjIsZXRiwiI9ETO6kjN5EzMzQjNzUjMiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUjx4MPJ6dFZFWwpUMVhFVkV6Ty3EMUhWQSJ5Yys6NBFWazp6RiJGNJFFZt5WODRGeiVjVjREVnFEcCtyZoJldmFkSjxGdxJlMMl5cUZlcjB7dX9GVDZTbyATNZp7LxE6agNzV';
